import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/Minus.tsx
const MinusIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("rect", {
		x: 4,
		y: 11,
		width: 16,
		height: 2,
		rx: 1,
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { MinusIcon };
